import { Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { TicketInfoManage } from './ticket-infoManage';

export const TicketInfoManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void   }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [paymentDate, setPaymentDate] = useState<string>();
    const [invoiceNumber, setInvoiceNumber] = useState<string>();

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Update Ticket Info" } onClose={params.onClose} />

            <TicketInfoManage onSave={params.onSave} setPaymentDate={setPaymentDate} setInvoiceNumber={setInvoiceNumber} />
        </Drawer>
    );
};